module.exports = __webpack_public_path__ + "img/rank12.4c4d07a2.png";